// Estructura geográfica de Venezuela: Estados, Municipios y Parroquias
export const venezuelaLocations = {
  "Distrito Capital": {
    municipalities: {
      "Libertador": ["Altagracia", "Antimano", "Candelaria", "Caricuao", "Catedral", "Coche", "El Junquito", "El Paraíso", "El Recreo", "El Valle", "La Candelaria", "La Pastora", "La Vega", "Macarao", "San Agustín", "San Bernardino", "San José", "San Juan", "San Pedro", "Santa Rosalía", "Santa Teresa", "Sucre", "23 de Enero"]
    }
  },
  "Miranda": {
    municipalities: {
      "Baruta": ["Baruta", "El Cafetal", "Las Minas de Baruta"],
      "Chacao": ["Chacao"],
      "El Hatillo": ["El Hatillo"],
      "Sucre": ["Caucagüita", "Filas de Mariche", "La Dolorita", "Leoncio Martínez", "Petare"],
      "Plaza": ["Guarenas"],
      "Zamora": ["Guatire"],
      "Carrizal": ["Carrizal"],
      "Los Salias": ["San Antonio de Los Altos"],
      "Cristóbal Rojas": ["Charallave"],
      "Independencia": ["Santa Teresa del Tuy", "Cartanal"],
      "Páez": ["Río Chico", "San Fernando del Guapo"],
      "Otro": []
    }
  },
  "Vargas": {
    municipalities: {
      "Vargas": ["Caraballeda", "Carayaca", "Catia La Mar", "El Junko", "La Guaira", "Macuto", "Maiquetía", "Naiguatá"],
      "Otro": []
    }
  },
  "Aragua": {
    municipalities: {
      "Girardot": ["Maracay", "Andrés Eloy Blanco", "Los Tacariguas", "Las Delicias", "Joaquín Crespo", "Pedro José Ovalles", "San José"],
      "Mario Briceño Iragorry": ["El Limón", "Caña de Azúcar"],
      "José Félix Ribas": ["La Victoria", "Zuata"],
      "Santiago Mariño": ["Turmero"],
      "Sucre": ["Cagua"],
      "Otro": []
    }
  },
  "Carabobo": {
    municipalities: {
      "Valencia": ["Candelaria", "Catedral", "El Socorro", "Miguel Peña", "Rafael Urdaneta", "San Blas", "San José", "Santa Rosa"],
      "Naguanagua": ["Naguanagua"],
      "San Diego": ["San Diego"],
      "Los Guayos": ["Los Guayos"],
      "Puerto Cabello": ["Bartolomé Salom", "Democracia", "Fraternidad", "Goaigoaza", "Juan José Flores", "Unión"],
      "Otro": []
    }
  },
  "Zulia": {
    municipalities: {
      "Maracaibo": ["Antonio Borjas Romero", "Bolívar", "Cacique Mara", "Caracciolo Parra Pérez", "Cecilio Acosta", "Cristo de Aranza", "Coquivacoa", "Chiquinquirá", "Francisco Eugenio Bustamante", "Idelfonso Vásquez", "Juana de Ávila", "Luis Hurtado Higuera", "Manuel Dagnino", "Olegario Villalobos", "Raúl Leoni", "Santa Lucía", "Venancio Pulgar", "San Isidro"],
      "San Francisco": ["Domitila Flores", "Francisco Ochoa", "Los Cortijos", "Marcial Hernández"],
      "Cabimas": ["Ambrosio", "Carmen Herrera", "La Rosa", "Germán Ríos Linares", "San Benito", "Rómulo Betancourt", "Jorge Hernández", "Punta Gorda", "Arístides Calvani"],
      "Otro": []
    }
  },
  "Lara": {
    municipalities: {
      "Iribarren": ["Aguedo Felipe Alvarado", "Buena Vista", "Catedral", "Concepción", "El Cují", "Juan de Villegas", "Juárez", "Santa Rosa", "Tamaca", "Unión"],
      "Palavecino": ["Cabudare", "José Gregorio Bastidas", "Agua Viva"],
      "Otro": []
    }
  },
  "Táchira": {
    municipalities: {
      "San Cristóbal": ["La Concordia", "Pedro María Morantes", "San Juan Bautista", "San Sebastián", "Dr. Francisco Romero Lobo"],
      "Cárdenas": ["Táriba"],
      "Otro": []
    }
  },
  "Mérida": {
    municipalities: {
      "Libertador": ["Arias", "Caracciolo Parra Olmedo", "Domingo Peña", "El Llano", "Gonzalo Picón Febres", "Jacinto Plaza", "Juan Rodríguez Suárez", "Lasso de la Vega", "Mariano Picón Salas", "Milla", "Osuna Rodríguez", "Sagrario", "El Morro", "Los Nevados"],
      "Otro": []
    }
  },
  "Bolívar": {
    municipalities: {
      "Heres": ["Catedral", "Marhuanta", "José Antonio Páez", "Orinoco", "La Sabanita", "Vista Hermosa", "Unare", "Yocoima", "5 de Julio"],
      "Caroní": ["Once de Abril", "Cachamay", "Chirica", "Dalla Costa", "Ciudad Piar", "Simón Bolívar", "Unare", "Universidad", "Vista al Sol", "Porvenir", "Yocoima"],
      "Otro": []
    }
  },
  "Anzoátegui": {
    municipalities: {
      "Simón Bolívar": ["Barcelona", "El Carmen", "San Cristóbal", "Bergantín", "Caigua", "El Pilar", "Naricual"],
      "Sotillo": ["Puerto La Cruz", "Pozuelos"],
      "Guanta": ["Guanta"],
      "Otro": []
    }
  },
  "Amazonas": { municipalities: { "Otro": [] } },
  "Apure": { municipalities: { "Otro": [] } },
  "Barinas": { municipalities: { "Otro": [] } },
  "Cojedes": { municipalities: { "Otro": [] } },
  "Delta Amacuro": { municipalities: { "Otro": [] } },
  "Falcón": { municipalities: { "Otro": [] } },
  "Guárico": { municipalities: { "Otro": [] } },
  "Monagas": { municipalities: { "Otro": [] } },
  "Nueva Esparta": { municipalities: { "Otro": [] } },
  "Portuguesa": { municipalities: { "Otro": [] } },
  "Sucre": { municipalities: { "Otro": [] } },
  "Trujillo": { municipalities: { "Otro": [] } },
  "Yaracuy": { municipalities: { "Otro": [] } }
};
